import { Base64 } from 'js-base64';
import qs from 'qs';
import { ajax } from 'rxjs/ajax';
import { partition, merge, of } from 'rxjs';
import { filter, map, switchMap, tap, catchError } from 'rxjs/operators';
import config from '../../isomorphic';
import util from '../utils';
import { message } from 'antd';

const c = config.cookie.split(';').reduce((accu, item) => {
  if (item.indexOf('=') !== -1) {
    const [key, value] = item.split('=');
    accu[key.replace(/^\s*|\s*$/g, '')] = value;
  }
  return accu;
}, {});
const DEV_CSFR_KEY = c.NTESSTUDYSI;
const DEFAULT_CSRF_KEY = 'c004baef84b645b8bfc8a564fb415f3b';

const getProjectorReturnUrl = () => {
  const url = new URL(window.location.href);
  url.protocol = 'https:';
  url.host = 'tp.icourse163.org';
  url.pathname = '/';
  return url.toString();
};

let isRefreshingCsrf = false;
const refreshCsrfCookie = () => {
  if (isRefreshingCsrf) return;
  isRefreshingCsrf = true;
  const encodedReturnUrl = encodeURIComponent(
    Base64.encode(getProjectorReturnUrl()),
  );
  window.location.href =
    `https://www.icourse163.org/mooc/main/clearCookie` +
    `?returnUrl=${encodedReturnUrl}`;
};
const DEFAULT_CONTENT_TYPE = 'application/x-www-form-urlencoded;charset=utf-8';
export const RESPONES_CODE = {
  OK: 0,
  NOT_LOGIN: 1,
  NO_PERMISSION: 2,
  NO_OPERATION: -1,
  MSG_MODAL: -2,
  MSG_TOAST: -3,
};

const getCookieMap = doc =>
  doc?.cookie
    ?.replace(/(^\s*)|(\s*$)/g, '')
    .split(';')
    ?.reduce((accu, item) => {
      if (item === '') return accu;
      const [key, value] = item.split('=');
      // eslint-disable-next-line no-param-reassign
      accu[key.replace(/(^\s*)|(\s*$)/g, '')] = value.replace(
        /(^\s*)|(\s*$)/g,
        '',
      );
      return accu;
    }, {});

const setScope = scope => {
  const str = JSON.stringify({ scope });
  return Base64.encode(str);
};

const getCsrfKey = doc => {
  const cookie = getCookieMap(doc);
  // if (__DEV__) {
  //   if (Object.keys(cookie).length === 0 || !cookie.NTESSTUDYSI) {
  //     document.cookie = `NTESSTUDYSI=${DEV_CSFR_KEY};path=/;domain=.icourse163.org;max-age-1`;
  //   }
  //   return DEV_CSFR_KEY;
  // }
  const csrfKey = cookie && cookie.NTESSTUDYSI;
  if (!csrfKey || csrfKey === DEFAULT_CSRF_KEY) {
    if (typeof window !== 'undefined') {
      refreshCsrfCookie();
    }
    return null;
  }
  return csrfKey;
};

const getUrl = (url, csrfKey) => {
  return `//www.icourse163.org${url}?csrfKey=${csrfKey}`;
  // return `${
  //   isDebug ? '' : 'http://www.icourse163.org'
  // }${url}?csrfKey=${csrfKey}`;
};

const fetch = ({ doc }) => {
  return ({
    url,
    method = 'POST',
    headers = {},
    body = {},
    scope = undefined,
    file = false, // 是否为file上传
    withCredentials = true, // 是否需要携带cookie（如nos上传接口不需要）
    isNeedCsrfKey = true, // url是否需要加上CsrfKey（如nos上传接口不需要）
    raw = false,
    createXHR = () => new XMLHttpRequest(), // 上传组件需要用到xhr来获取进度条
  }) => {
    const csrfKey = getCsrfKey(doc);
    if (!csrfKey) return of(null).pipe(filter(() => false));
    const m = method.toUpperCase();
    // const u = `${getUrl(url, csrfKey)}${
    //   m === 'GET' && Object.keys(body).length > 0
    //     ? `&${qs.stringify(body)}`
    //     : ''
    //   }`;
    const prefix = '//www.icourse163.org';
    const formatUrl = `${url.startsWith('http') ? '' : prefix}${url}${
      url.indexOf('?') !== -1 ? '&' : '?'
    }csrfKey=${csrfKey}${
      method.toUpperCase() === 'GET' && Object.keys(body).length > 0
        ? `&${qs.stringify(body)}`
        : ''
    }`;
    const u = isNeedCsrfKey ? formatUrl : url;
    const errorHandle = (code, mes) => {
      message.destroy('loading');
      mes && message.error(mes);
    };
    util.log.p('url ==> ', u);
    return ajax({
      url: u,
      method: m,
      headers: file // 沿袭h5项目判断
        ? {}
        : {
            'Content-Type': DEFAULT_CONTENT_TYPE,
            'edu-script-token': csrfKey,
            ...headers,
            ...(scope ? { 'eds-scope': setScope(scope) } : {}),
          },
      body,
      crossDomain: true,
      withCredentials,
      createXHR,
    }).pipe(
      switchMap(resp => {
        if (file) {
          // 沿袭h5项目判断
          return of(resp.response);
        }
        const [normal$, error$] = partition(of(resp), ({ response }) => {
          return raw === true || (response && response.code === 0);
        });
        return merge(
          normal$.pipe(
            tap(r => {
              util.log.p('ajax success ==> ', r);
            }),
            map(({ response: { result }, response }) =>
              raw === true ? response : result,
            ),
          ),
          error$.pipe(
            map(({ response }) => {
              let errType;
              errorHandle(response.code, response.message);
              switch (response.code) {
                case RESPONES_CODE.NOT_LOGIN:
                  errType = RESPONES_CODE.NOT_LOGIN;
                  break;
                case RESPONES_CODE.NO_PERMISSION:
                  errType = RESPONES_CODE.NO_PERMISSION;
                  break;
                case RESPONES_CODE.NO_OPERATION:
                  errType = RESPONES_CODE.NO_OPERATION;
                  break;
                case RESPONES_CODE.MSG_MODAL:
                  errType = RESPONES_CODE.MSG_MODAL;
                  break;
                case RESPONES_CODE.MSG_TOAST:
                  errType = RESPONES_CODE.MSG_TOAST;
                  break;
                default:
                  errType = response.code;
                  break;
              }
              util.log.p(
                'error happens:',
                url,
                response.message,
                response.code,
              );
              return {
                sysErr: true,
                errType,
                msg: response.message,
              };
            }),
          ),
        );
      }),
      catchError(error => {
        console.log('error: ', error);
        return {
          sysErr: true,
          errType: 'System Error',
          msg: error,
        };
      }),
      filter(data => {
        if (data?.sysErr) {
          util.log.p('backend no response back ==> ', data);
          return false;
        }
        return !data?.sysErr;
      }),
    );
  };
};

export default fetch;
